import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import CallMeDialog from './register';
import { Route, Routes } from 'react-router';
import Home from './home';
import Kit1 from './kit1';
import Order from './order';
import Products from './products';
import About from './about';
import Guide from './guide';
import Contact from './contact';
import BrahmacharyaSEO from './BrahmacharyaSEO';

function App() {
   
  return (    
   <>
      <BrahmacharyaSEO/>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='kit1' element={<Kit1/>} />
        <Route path='orderkit/:id' element={<Order/>} />
        <Route path='orderkit/:id' element={<Order/>} />
        <Route path='products' element={<Products/>} />
        <Route path='about' element={<About/>} />
        <Route path='guide' element={<Guide/>} />
        <Route path='contact' element={<Contact/>} />
      </Routes>
   </>
  );  
}

export default App;
